import type { ResourceContext } from '../types';

export type InitialPromptInput = {
  /** Chat session the prompt was stashed for; the WS claims it on connect by this id. */
  chatSessionId: string;
  files?: File[];
  prompt: string;
  agentVersionId?: string;
  /** Resource the chat is about; carried to the first WS message. */
  context?: ResourceContext;
  /** Resources the user @-mentioned in the first message; carried to the first WS message so
   *  its bubble renders the snapshotted names, not raw ids (matches subsequent-message sends). */
  mentions?: ResourceContext[];
};

let current: InitialPromptInput | undefined;

export const setInitialPrompt = (input: InitialPromptInput) => {
  current = input;
};

export const peekInitialPrompt = (chatSessionId: string | undefined): InitialPromptInput | undefined => {
  if (!chatSessionId) return undefined;
  return current?.chatSessionId === chatSessionId ? current : undefined;
};

export const consumeInitialPrompt = (chatSessionId: string | undefined): InitialPromptInput | undefined => {
  const result = peekInitialPrompt(chatSessionId);
  if (result) current = undefined;
  return result;
};
